<template>
  <div class="Regular" id="main" ref="main" :style="{ overflowX: isMagazine ? 'visible' : '' }" :class="{ 'overflowp-hidden': isLoading || openMenu, 'blackPage': isBlackPage }">
    <!-- 123 blackPage-->
    <div ref="headerContent">
      <Header v-bind:logGaEvent="logGaEvent" v-bind:isMagazine="isMagazine" id="header" ref="header" :class="{ 'headerMB': $store.state.innerWidth <= 1080 }"></Header>
    </div>
    <div ref="content">
      <keep-alive
        include="coursesDetail,jobDetail,privacyPolicy,disclaimer,siteMap,aboutUs,resources,occupationDetails,browseOccupations,BrowseCourses,FindAnOpportunity,onlineMagazineDetail,onlineMagazine"
      >
        <router-view v-bind:logGaEvent="logGaEvent" id="content" ref="rou" :style="{ overflow: isMagazine ? 'visible' : '' }" :class="{ 'contentMB': $store.state.innerWidth <= 1080 }"></router-view>
      </keep-alive>
    </div>
    <div ref="footerContent" @click="closeSelectList">
      <Footer v-if="showFooter" v-bind:logGaEvent="logGaEvent" ref="footerContain" id="footer" :class="{ 'footerPC': $store.state.innerWidth > 768 }"></Footer>
    </div>
    <Loading v-show="isLoading"></Loading>
    <div ref="gotoTop" v-show="showTop" role="button" aria-label="Go To Top Button" @click="gotoTopEvent" class="goTopBtn" :class="{ 'goTopBtnMB': $store.state.innerWidth <= 768 }">
      <a href="javascript:;" style="color: inherit">
        <img src=".././../images/top1.png" />
      </a>
    </div>
    <v-dialog />
    <modals-container :class="{ 'quizPopup': $route.name == 'careerMatches' }" />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Loading from "@/components/Loading.vue";
import { EventBus } from "../../javascripts/eventBus.js";
import Popup from "@/components/Popup.vue";
import iePopup from "@/components/iePopup.vue";
import successPopup from "@/components/successPopup.vue";
import formPopup from "@/components/formPopup.vue";
export default {
  components: {
    Header,
    Footer,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      openMenu: false,
      showTop: false,
      showFooter: true,
      errorPopup: false,
      errorMsg: {},
      successPopup: false,
      successMsg: {},
      tipPopup: false,
      tipMsg: {},
      es6Popup: false,
      isMagazine: false,
      isBlackPage: false,
    };
  },
  metaInfo() {
    return {
      meta: [
        {
          property: "og:title",
          content: this.$store.state.mate.title,
        },
        {
          property: "og:url",
          content: this.$store.state.mate.url,
        },
        {
          property: "og:description",
          content: this.$store.state.mate.description,
        },
        {
          property: "og:image",
          content: this.$store.state.mate.image,
        },
        {
          property: "og:image:secure_url",
          content: this.$store.state.mate.image,
        },
        {
          property: "og:image:type",
          content: this.$store.state.mate.imageType,
        },
        {
          property: "og:image:width",
          content: this.$store.state.mate.width,
        },
        {
          property: "og:image:height",
          content: this.$store.state.mate.height,
        },
        {
          property: "twitter:title",
          content: this.$store.state.mate.title,
        },
        {
          property: "twitter:description",
          content: this.$store.state.mate.description,
        },
        {
          property: "twitter:image",
          content: this.$store.state.mate.image,
        },
        {
          name: "title",
          content: this.$store.state.mate.title,
        },
        {
          name: "description",
          content: this.$store.state.mate.description,
        },
        {
          name: "image",
          content: this.$store.state.mate.image,
        },
        {
          name: "keywords",
          content: this.$store.state.mate.keywords,
        },
      ],
    };
  },
  mounted() {
    var that = this;

    EventBus.$on("loading", msg => {
      that.isLoading = msg.turn == "on";
    });
    EventBus.$on("error", msg => {
      that.isLoading = msg.errMsg == "on";

      that.$modal.show("dialog", {
        title: "Error!",
        text: msg.errMsg,
        buttons: [
          {
            title: "Close",
          },
        ],
      });
    });
    EventBus.$on("success", msg => {
      that.isLoading = msg.errMsg == "on";

      that.$modal.show(
        successPopup,
        {
          text: "",
          title: msg.title,
        },
        {
          height: "auto",
          width: "90%",
          maxWidth: 800,
        }
      );
    });
    EventBus.$on("showPopup", msg => {
      this.$modal.show(
        Popup,
        {
          text: msg.text,
          title: msg.title,
        },
        {
          height: "auto",
          width: "90%",
          maxWidth: 800,
        }
      );
    });
    EventBus.$on("formPopup", msg => {
      this.$modal.show(
        formPopup,
        {
          title: msg.title,
          scoreType: msg.scoreType,
          occupationsList: msg.occupationsList,
        },
        {
          height: "auto",
          width: "90%",
          maxWidth: 800,
        }
      );
    });
    EventBus.$on("closeBanner", () => {
      if (1345 < this.$store.state.innerWidth < 1450) {
        this.$refs.gotoTop.style.bottom = "60px";
      } else if (this.$store.state.innerWidth < 1080) {
        this.$refs.gotoTop.style.bottom = "60px";
      }
    }),
      that.setWidth();
    window.onresize = () => {
      that.setWidth();
    };
    if (this.$route.name != "home") {
      this.$refs.gotoTop.style.bottom = "60px";
    }
    if (this.$route.name == "onlineMagazine") {
      this.isMagazine = true;
    } else {
      this.isMagazine = false;
    }
  },
  methods: {
    closeSelectList: function () {
      if (this.$refs.rou.$refs.Pa) {
        this.$refs.rou.$refs.Pa.closeSelecPagingList();
      }
      if (this.$refs.rou.$refs.Page) {
        this.$refs.rou.$refs.Page.closeSelecPagingList();
      }
    },
    changeHideFoorter: function () {
      if (this.$store.state.innerWidth <= 992) {
        this.showFooter = false;
      }
    },
    changeShowFoorter: function () {
      this.showFooter = true;
    },
    openMenuEvent: function () {
      this.$refs.main.style.height = window.innerHeight + "px";
      this.openMenu = true;
    },
    closeMenuEvent: function () {
      this.$refs.main.style.height = "auto";
      this.openMenu = false;
    },
    logGaEvent: function (eventCategory, eventAction, eventLabel, eventValue) {
      this.$gtag.event(eventAction, {
        eventCategory: eventCategory,
        eventLabel: eventLabel,
        eventValue: eventValue,
      });
    },
    gotoTopEvent: function () {
      window.scrollTo(0, 0);
      this.showTop = false;
    },
    setWidth: function () {
      this.$store.state.innerWidth = window.innerWidth;
      this.$store.state.innerHeight = window.innerHeight;
      this.$refs.header.setHight();
      // this.$refs.content.style.minHeight = window.innerHeight - this.$refs.footerContent.offsetHeight +'px';
      if (this.openMenu) {
        this.$refs.main.style.height = window.innerHeight + "px";
      }
      if (this.$store.state.innerWidth > 768) {
        this.$store.state.swiperOption = {
          slidesPerView: 2.2,
          spaceBetween: 15,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        };
      } else {
        this.$store.state.swiperOption = {
          slidesPerView: 2.2,
          spaceBetween: 0,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        };
      }
      // var height = this.$refs.main.scrollHeight;
      // if(height>this.$refs.main.offsetHeight){
      //     height = this.$refs.main.offsetHeight;
      // }
      // window.scrollTo(0,height);
      // setTimeout(function(){
      //     window.scrollTo(0,height);
      // })
    },
  },

  created() {
    var that = this;

    this.api.checkSystemTheme({}, function (data) {
      if (data.errorCode == 0) {
        that.isBlackPage = data.result;
      }
    });
    setTimeout(function () {
      document.title = that.$i18n.t("message." + that.$route.meta.title) + " - talent.gov.hk - " + that.$i18n.t("message.Default Page Title");
      that.$store.state.mate.title = that.$i18n.t("message." + that.$route.meta.title) + " - talent.gov.hk - " + that.$i18n.t("message.Default Page Title");
      that.$store.state.mate.keywords = that.$i18n.t("message.Default Keywords");
    });

    if (sessionStorage.getItem("formData")) {
      var formData = JSON.parse(sessionStorage.getItem("formData"));

      that.$store.state.formData = formData;
      that.$store.state.formData.headTabState = true;
      // that.$store.state.formData.oneTabState = true;
    }
    this.$router.beforeEach((to, from, next) => {
      that.$store.state.mate.title = "talent.gov.hk - " + that.$i18n.t("message.Default Page Title");
      that.$store.state.mate.image = "https://saprdwebsto01.blob.core.windows.net/assets/image/logo_.png";
      that.$store.state.mate.keywords = that.$i18n.t("message.Default Keywords");
      that.$store.state.mate.description = that.$i18n.t("message.description");
      that.$store.state.mate.width = 1000;
      that.$store.state.mate.height = 800;
      sessionStorage.setItem("formData", JSON.stringify(that.$store.state.formData));

      var breadcrumbsC = to.meta.breadcrumbs.find(b => b.to.indexOf("coursesDetail") > 0);
      if (breadcrumbsC) {
        breadcrumbsC.text = "";
      }
      var breadcrumbsO = to.meta.breadcrumbs.find(b => b.to.indexOf("occupationDetails") > 0);
      if (breadcrumbsO) {
        breadcrumbsO.text = "";
      }

      var breadcrumbsJ = to.meta.breadcrumbs.find(b => b.to.indexOf("jobDetail") > 0);
      if (breadcrumbsJ) {
        breadcrumbsJ.text = "";
      }
      var breadcrumbsM = to.meta.breadcrumbs.find(b => b.to.indexOf("onlineMagazineDetail") > 0);
      if (breadcrumbsM) {
        breadcrumbsM.text = "";
      }

      if (to.name == "onlineMagazine") {
        this.$store.state.zi = "All";
      } else if (to.name == "onlineFeactureStory") {
        this.$store.state.zi = "Feature Story";
      } else if (to.name == "onlineSideStory") {
        this.$store.state.zi = "Side Story";
      } else if (to.name == "onlineColumn") {
        this.$store.state.zi = "Column";
      }

      next();
      // console.log(from);
      // console.log(to);
      // console.log(document.documentElement.scrollTop||document.body.scrollTop)
      // if(to.name == "onlineMagazine"||to.name == "browseOccupations"||to.name == "findAnOpportunity"||to.name == "browseCourses"||to.name == "selfAssessment"){
      //     this.$store.state.formData.oneTabState = false;
      // }else{

      //     this.$store.state.formData.oneTabState = true;

      // }

      // if (!to.query.lang) {
      //     to.query.lang = that.$store.state.language;
      //     next({ path: to.path, query: to.query });
      // } else {
      if (to.meta.title && that.$i18n != null) {
        that.$store.state.mate.title = document.title = that.$i18n.t("message." + to.meta.title) + " - talent.gov.hk - " + that.$i18n.t("message.Default Page Title");
      }
      next();
      // }
    });
    window.addEventListener("scroll", function () {
      if (window.scrollY > 200) {
        that.showTop = true;
      } else {
        that.showTop = false;
      }
    });
    this.$store.getters.formatDate = function (input) {
      if (!input) return;
      var timeStampArray = input.split(/[. -/:]/);
      if (!timeStampArray[3]) {
        timeStampArray[3] = "00";
      }
      if (!timeStampArray[4]) {
        timeStampArray[4] = "00";
      }
      if (!timeStampArray[5]) {
        timeStampArray[5] = "00";
      }
      var timeStamp = new Date(timeStampArray[0], timeStampArray[1] - 1, timeStampArray[2], timeStampArray[3], timeStampArray[4], timeStampArray[5]);
      var year = timeStamp.getFullYear();
      var month = timeStamp.getMonth();
      var date = timeStamp.getDate();
      if (date < 10) {
        date = "0" + date;
      }
      var x = "";
      if (that.$store.state.language == "en_US") {
        x = date + " " + that.$store.state.monthArray[month] + " " + year;
      } else {
        month++;
        x = year + that.$i18n.t("message.Year") + month + that.$i18n.t("message.Month") + date + that.$i18n.t("message.Day");
      }
      return x;
    };
    try {
      Function("() => {};");
    } catch (exception) {
      setTimeout(function () {
        that.$modal.show(
          iePopup,
          {},
          {
            height: "auto",
            width: "90%",
            maxWidth: 1300,
          }
        );
      });
    }
  },
  updated() {},
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.name != "home") {
          this.$refs.gotoTop.style.bottom = "60px";
        } else {
          if (this.$store.state.innerWidth > 1450) {
            this.$refs.gotoTop.style.bottom = "60px";
          } else if (this.$store.state.innerWidth > 1345) {
            this.$refs.gotoTop.style.bottom = "210px";
          } else if (this.$store.state.innerWidth > 1080) {
            this.$refs.gotoTop.style.bottom = "60px";
          } else {
            this.$refs.gotoTop.style.bottom = "210px";
          }
        }
        if (val.name == "onlineMagazine") {
          this.isMagazine = true;
        } else {
          this.isMagazine = false;
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
};
</script>
